module.exports = __webpack_public_path__ + "img/4e1e90f.png";